import React from 'react';
import PropTypes from 'prop-types';
import { CdnImage } from '@buzzfeed/react-components';
import downsizeImage from '../../../../utils/downsizeImage';
import styles from './headline-dateline.module.scss';

const HeadlineDateline = ({ dateline }) => {
  const imageUrl = `https://img.buzzfeed.com/buzzfeed-static${dateline.dateline_image}`;
  return (
    <div className={styles.dateline}>
      <CdnImage
        src={downsizeImage(imageUrl)}
        className={styles.dateline_map}
        alt={`Map of ${dateline.name}`}
      />
      <div className="xs-flex-grow-1">
        <p className={styles.datelineTitle}>Reporting From</p>
        <strong className={styles.datelineName}>{dateline.name}</strong>
      </div>
    </div>
  );
};

HeadlineDateline.propTypes = {
  dateline: PropTypes.shape({
    name: PropTypes.string.isRequired,
    dateline_image: PropTypes.string.isRequired,
  }),
};

export default HeadlineDateline;
